export default "__VITE_PUBLIC_ASSET__6e26df1b__"